// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import {
  ChatListToolboxCulturalContentsModal,
  ChatListToolboxCulturalContentsModalProps,
} from './chat-list-toolbox-cultural-contents-modal'

const CULTURAL_CONTENTS_COMPONENT_ID = 'chatListToolboxCulturalContents'

export const showChatListToolboxCulturalContentsModal = async (
  props?: ChatListToolboxCulturalContentsModalProps,
) => {
  addModal({ id: CULTURAL_CONTENTS_COMPONENT_ID, props })
}

export default {
  [CULTURAL_CONTENTS_COMPONENT_ID]: {
    Component: ChatListToolboxCulturalContentsModal,
  },
}
